var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"logo-right",attrs:{"src":require("./assets/logo-dc.svg")}}),_c('vue-page-transition',{staticClass:"h-100",attrs:{"name":"fade-in-right"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }